export default {
	selectUnit: {
		txtTitle: 'Selecciona tu unidad',
		txtNotification: 'Unidad asignada con exito',
		txtAvailable: 'unidades disponibles',
		txtEmpty: 'No hay unidades disponibles'
	},
  global: {
    txtDelete: "Eliminar",
    /* email: "Correo o numero de telefono", */
    email: "Correo",
    emailRecover: "Correo",
    password: "Contraseña",
    rules: {
      passwordLength: "Mínimo 8 caracteres",
      passwordRequired: "Se requiere contraseña",
      emailRequired: "Requerido",
      emailValid: "E-mail no es valida",
      passwordNoMatch: "Las contraseñas no coinciden",
    },
    snackbar: {
      close: "Cerrar",
    },
    navigation: {
      txtServices: "Servicios",
      txtHistory: "Histórico",
      txtChecking: "Check In",
    },
    dialog: {
      btnCancel: "Cancelar",
      btnToAccept: "Aceptar",
      btnUpdate: "Actualizar",
    },
    components: {
      services: {
        txtCalendar: "Servicios del",
      },
      qrReader: {
        txtTitle: "Check in",
        txtInfo:
          "Favor de centrar el codigo QR para aplicar el Check In del pasajero.",
        txtServiceNoAsign:
          "El servicio que esta buscando no existe o no se le ha asignado",
        txtErrorGeneric:
          "Ocurrio un error al realizar el checkin del servicio.",
        txtInfoSelect:
          "Seleccione el tipo de checkin, de preferencia el uso de QR.",
        txtOptions: "Opciones",
        txtTitleCheckinM: "Checkin Manual",
        txtDescM:
          "Se aplicara un checkin manual, tome en cuenta que se monitorea en todo tiempo.",
      },
      listServices: {
        txtEmptyServices: "Sin servicios",
        txtSearch: "ID del servicio",
      },
      empty: {
        txtEmptyData: "No existen datos",
      },
      history: {
        txtCalendar: "Historial del",
      },
      noshow: {
        txtPhoto1:
          "Tómate una foto con el letrero del nombre del cliente, en el punto de encuentro de fondo.",
        txtPhoto2:
          "Toma una foto del vehículo con el fondo del lugar de pickup.",
        txtPhoto3:
          "Toma una foto de un formato impreso que atestigüe el No show (formato de no show, ticket de estacionamiento, pase de salida del pax).",
      },
      offline: {
        txtTitle: "Offline",
        txtOffline: "Sin conexión",
      },
    },
    savedSuccessfully:"Realizado con éxito.",
    gpsRequiredAlert:"El acceso a la ubicación es requerido para continuar. Por favor, habilita los permisos de GPS en la configuración de tu navegador",
    today:"Hoy"
  },
  login: {
    txtWelcome: "Bienvenido",
    txtSubtitle: "Ingresa tus credenciales",
    emailPlaceholder: "tu@email.com",
    passwordPlaceholder: "Tu contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    btnLogin: "Iniciar sesión",
    btnInstallApp: "Instalar App",
    txtErrorRetrievingUserData: "Error al recuperar los datos del usuario",
    txtEmailPasswordInvalid: "Correo o contraseña inválidos",
  },
  recover: {
    txtResetTitle: "Nueva contraseña",
    txtResetSubtitle: "Ingresa tu nueva contraseña",
    updateTitle: "Cambiar contraseña",
    updateSubtitle: "Ingresa tu nueva contraseña",
    newPassword: "Nueva contraseña",
    newPasswordPlaceholder: "Mínimo 8 caracteres",
    repeatPassword: "Confirmar contraseña",
    repeatPasswordPlaceholder: "Repite la contraseña",
    btnUpdatePassword: "Cambiar contraseña",
    txtErrorUpdate: "Ocurrió un problema al actualizar la contraseña.",
    txtSuccessUpdate: "Contraseña actualizada con éxito"
  },
  listChat: {
    txtTitle: "Mensajes",
    txtConversations: "conversaciones",
    today: "Hoy",
    noMessages: "Sin Mensajes",
  },
  home: {
    profile: "Perfil",
    logout: "Salir",
    waiting: "Espere un momento",
    txtHelpSupport: "Servicio de asistencia",
    txtButtomUpdate: "Buscar actualización",
    txtSelectUnit: 'Seleccionar Unidad',
		txtLicense: 'Licencia',
		txtUnit: 'Unidad',
		txtPlates: 'Placas'
  },
  forgot: {
    txtTitle: "Recuperar contraseña",
    txtSubtitle: "Ingresa tu correo para recuperar tu contraseña",
    emailPlaceholder: "tu@email.com",
    btnReturnToLogin: "Volver a Login",
    btnBackToLogin: "Volver al inicio de sesión",
    btnSendEmail: "Enviar Email",
    txtEmaildSend:
      "Se envió un correo electrónico de recuperación de contraseña.",
    txTunexpectedError: "Ocurrió un error inesperado",
  },
  chat: {
    newMessage: "Nuevo Mensaje",
    txtNoLoggetForChat: "No registrado para chatear",
    txtLocked: "Chat bloqueado",
    txtLockedMessage: "La funcionalidad de chat ha sido deshabilitada. Este servicio ya no está en operación.",
    txtError: "Algo salió mal",
    txtErrorMessage: "No pudimos cargar el chat. Por favor intenta de nuevo.",
    btnBack: "Volver",
    btnRetry: "Reintentar",
  },
  booking: {
    pickupOn: "Recoger en",
    at: "a",
    dropoffAt: "Dejar en",
    flight: "Vuelo",
    flightNumber: "Número de vuelo",
    fligthTime: "Tiempo de vuelo",
    notes: "Notas",
    txtErrorServiceInProcess: "Ya cuenta con otro servicio en proceso",
    txtErrorNoMatchQr: "El servicio actual no coincide con el QR.",
    txtErrorNoShow: "Notificara que no encontro al cliente.",
    txtError60Min: "Aun no pasan 60 minutos",
    txtError15Min: "Aun no pasan 15 minutos",
    txtErrorNoTrip: "No se reconoce el tipo del Viaje",
    txtNoShowNotAllowed: "No Show no permitido",
    txtNoShowPlus: "para indicar un no show.",
    txtErrorChangeStatus: "Ocurrio un problema al cambiar el estado",
    txtChangeStatus: "Cambio de estado",
    dialog: {
      btnCancel: "Cancelar",
      btnToAccept: "Aceptar",
    },
    bookingStatusOpts: {
      txtActive: "Activo",
      txtNoShow: "No Show",
      txtNoProvided: "No atendido",
      txtCanceled: "Cancelado",
      txtDone: "Realizado",
    },
    steps: {
      pending: {
        btnText: "",
        txtLabel: "Pendiente",
        txtChangeStatusAlert: "El servicio esta como pendiente.",
      },
      onWayToPickup: {
        btnText: "Iniciar viaje al Origen",
        txtLabel: "Rumbo a $pickup",
        txtChangeStatusAlert: "Iniciara viaje para llegar a $pickup",
      },
      atPickup: {
        btnText: "He llegado al Origen",
        txtLabel: "En Origen para Pickup",
        txtChangeStatusAlert: "Avisara que ha llegado a $pickup",
      },
      onWayToDropoff: {
        btnText: "Iniciar viaje a Destino",
        txtLabel: "Rumbo a Destino",
        txtChangeStatusAlert: "Iniciara viaje para llegar a $dropoff",
      },
      finished: {
        btnText: "Fin del servicio",
        txtLabel: "Servicio finalizado",
        txtChangeStatusAlert: "Avisara que ha realizado el servicio con éxito",
      },
    },
    txtErrorCord: "Las coordenadas del servicio no son correctas.",
    txtErrorDistance: "Aun no se encuentra dentro del radio de un 5 KM.",
    txtGpsError: "GPS desactivo, favor de activarlo.",
  },
  profile: {
    txtFirstName: "Nombre",
    txtLastName: "Apellido",
    txtEmail: "Correo",
    txtLicenseNumber: "Número de licencia",
    txtTypeUser: "Tipo de usuario",
    txtLanguaje: "Idioma",
    txtPersonalInfo: "Información personal",
    txtSettings: "Configuración",
    txtLanguageHint: "Idioma de la aplicación",
    btnSave: "Guardar",
  },
  update: {
    txtTitle: "Actualizando Versión",
    txtUpdate: "Se descargo una nueva versión, favor de recargar la app.",
    btnReload: "Recargar app",
  },
  noShow: {
    txtTitle: "Evidencias de No Show",
    txtSubtitle: "Documenta la evidencia del No Show",
    txtInstructions: "Instrucciones",
    txtPhotos: "Fotos",
    txtNoPhotos: "Sin fotos agregadas",
    txtMinPhotos: "Mínimo 3 fotos requeridas",
    takePhoto: "Tomar foto",
    uploadImages: "Subir imágenes",
    notesPlaceholder: "Agrega notas adicionales (opcional)",
    btnSubmit: "Reportar No Show",
    txtUploading: "Subiendo evidencias en segundo plano...",
    txtUploadSuccess: "No Show reportado exitosamente",
    txtUploadError: "Error al reportar No Show, intenta de nuevo",
    txtAlertSuccessTitle: "Reporte Enviado",
    txtAlertErrorTitle: "Error en el Reporte",
  },
  qrReader: {
    manualDesc: "Check-in manual",
    qrDesc: "Escanear código",
    initializing: "Iniciando cámara...",
  },
  lblTrackingStatus: {
		pending: "Listo para iniciar",
		onWayToPickup: "Vas camino al punto de encuentro",
		atPickup: "Llegaste al punto de encuentro",
		onWayToDropoff: "Llevando al pasajero",
		finished: "Servicio completado",
	},
	flightStatus: {
		on_time: "En tiempo",
		landed: "Aterrizó",
		delayed: "Retrasado",
		cancelled: "Cancelado",
		early: "Adelantado",
		unknown: "Desconocido",
		delayedMinutes: "Demorado {minutes} min",
		earlyMinutes: "Adelantado {minutes} min",
	},
	flightModal: {
		title: "Información del Vuelo",
		origin: "Origen",
		route: "Ruta",
		status: "Estado",
		progress: "Progreso del vuelo",
		scheduledTime: "Hora programada",
		originalTime: "Hora de vuelo programada",
		estimatedLanding: "Aterrizaje estimado actual",
		estimatedGate: "Llegada a puerta actual",
		actualLanding: "Aterrizaje real",
		actualGate: "Llegada real a puerta",
		terminal: "Terminal",
		gate: "Puerta",
		landed: "Aterrizó",
		inFlight: "En vuelo",
		notDeparted: "No ha despegado",
		viewOnFlightStats: "Ver en FlightStats",
		na: "N/A",
		dataSource: "Fuente de datos",
		lastUpdate: "Última actualización",
		noDataAvailable: "No se encontraron datos del vuelo",
		noDataDescription: "La información del vuelo no está disponible en este momento. Intenta de nuevo más tarde.",
		flightUpdated: "El estado del vuelo se ha actualizado",
	}
}
